import React, { Component } from 'react';
import 'antd/dist/antd.css';
import { Form, Select, Button, Input } from 'antd';
import { Spinner } from 'reactstrap';
import axios from '../../utils/request';

const { Option } = Select;
let tenantId = "";
let errorMessage = "";
let commonParamater = "";
let formRef;
let stfName = "";
let stfCode = "";

const formLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 },
};

export class ZhuoYue extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isReady: false,
            isLoading: true,
            errorMessage: "",
            reqNos: [],
            personIds: "",
            tenantId: "",
            userId: "",
            reqNo: "",
            staffName: "",
            staffNo: "",
            stfName: "",
            stfCode: "",
            commonParamater: ""
        }
    };

    formRef = React.createRef();

    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        let commonParamater = urlParams.get("commonParamater");
        tenantId = urlParams.get("tenantId");
        let messageCode = urlParams.get("messageCode");
        if (!commonParamater) {
            this.setState({ errorMessage: "未能获取基本参数！", isLoading: false, isReady: true });
            return;
        }
        console.log("标准系统参数", commonParamater, tenantId);

        this.state.commonParamater = commonParamater;
        this.state.tenantId = tenantId;
        this.loadPage(tenantId, commonParamater);
        //this.loadPage(430585, "1246375d-34e8-4a0d-897d-613010ccf01d");
    };

    loadPage = (tenantId, commonParamater) => {
        const params = {
            tenantId,
            commonParamater
        }
        //卓越 https://service-bridge.recruit.italent.cn
        axios
            .get("/api/ZhuoYue/GetBPMJumpUrl", { params: params })
            .then(res => {
                console.log("卓越请求结果", res);
                let errorMessage = "";

                if (res.status == 200 && res.data.code == "200") {
                    if (res.data.data !== "") {
                        window.location.href = res.data.data;
                    } else {
                        errorMessage = "获取需求部门名称失败！"
                    }
                }
                else {
                    errorMessage = res.data.message;
                }
                this.setState({ isLoading: false, isReady: true, errorMessage });
            })
            .catch(reason => {
                console.log(reason);
                this.setState({ isLoading: false, isReady: true, errorMessage: "操作异常，请联系管理员！" });
            })
            .finally(
            );
    };

    render() {
        if (this.state.isReady) {
            if (this.state.errorMessage !== "") {
                return (<div style={{ textAlign: "center", padding: "32px" }}><span style={{ color: "red" }}>{this.state.errorMessage}</span></div>)
            }
        }
        else {
            return (
                <div style={{ textAlign: "center", padding: "15px" }}>
                    <Spinner type="grow" color="primary" />
                    <Spinner type="grow" color="secondary" />
                    <Spinner type="grow" color="success" />
                    <Spinner type="grow" color="danger" />
                    <Spinner type="grow" color="warning" />
                    <Spinner type="grow" color="info" />
                    <Spinner type="grow" color="dark" />
                </div>
            );
        }

    }
}